// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDtqDIfaa_SFUv_RnefsO3PENixqTRX3t0",
  authDomain: "yoga-curator.firebaseapp.com",
  projectId: "yoga-curator",
  storageBucket: "yoga-curator.appspot.com",
  messagingSenderId: "587620554787",
  appId: "1:587620554787:web:77fa21324a95354526b996"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);